<p>default-payment works!</p>
